export default __webpack_public_path__ + "static/Fredrik_Haga_Dune-257aeab27721ca5d3a9b532b38c22a72.png";